import { ToggleActions } from "../constants/constants";

const initialSwitches = {
    menu: true,
    graph: false,
    numbers: false,
    timeline: false,
    items: false,
    priceGraph: false,
    extendedGraph: false,
    signature: false,
    fullBuilding: true,
    loadingLevel: true,
    loadingItems: false,
    cardsLoading: false,
    plannedTimeline: false,
    axles: false,
    showAppartmentFilter: false,
    metrics: false,
    releaseDate: false,
    selectProtocol: false,
    refresh: false,
    legend: true,
    loadedMap: false,
    roadLabel: true,
    demo: false,
    editMode: false,
    changeCategory: false,
    changeLevel: false,
    signaturesFilter: false,
    createBreakMode: false,
    createBreakModal: false,
    addNewRegister: {show: false, value: null},
    tunnelSubdivisions: false,
    ganttChartDates: false,
}

const toggleActionsMap = {
    [ToggleActions.MENU]: 'menu',
    [ToggleActions.GRAPH]: 'graph',
    [ToggleActions.NUMBERS]: 'numbers',
    [ToggleActions.TIMELINE]: 'timeline',
    [ToggleActions.ITEMS]: 'items',
    [ToggleActions.EXTENDED_GRAPH]: 'extendedGraph',
    [ToggleActions.PRICE_GRAPH]: 'priceGraph',
    [ToggleActions.SIGNATURE]: 'signature',
    [ToggleActions.FULL_BUILDING]: 'fullBuilding',
    [ToggleActions.LOADING_LEVEL]: 'loadingLevel',
    [ToggleActions.LOADING_ITEMS]: 'loadingItems',
    [ToggleActions.CARDS_LOADING]: 'cardsLoading',
    [ToggleActions.PLANNED_TIMELINE]: 'plannedTimeline',
    [ToggleActions.AXLES]: 'axles',
    [ToggleActions.SHOW_APPARTMENT_FILTER]: 'showAppartmentFilter',
    [ToggleActions.METRICS]: 'metrics',
    [ToggleActions.RELEASE_DATE]: 'releaseDate',
    [ToggleActions.SELECT_PROTOCOL]: 'selectProtocol',
    [ToggleActions.REFRESH]: 'refresh',
    [ToggleActions.LEGEND]: 'legend',
    [ToggleActions.LOADED_MAP]: 'loadedMap',
    [ToggleActions.ROAD_LABEL]: 'roadLabel',
    [ToggleActions.DEMO]: 'demo',
    [ToggleActions.EDIT_MODE]: 'editMode',
    [ToggleActions.CHANGE_CATEGORY_COMPONENT]: 'changeCategory',
    [ToggleActions.CHANGE_LEVEL_COMPONENT]: 'changeLevel',
    [ToggleActions.SIGNATURES_FILTER]: 'signaturesFilter',
    [ToggleActions.CREATE_BREAK_MODE]: 'createBreakMode',
    [ToggleActions.CREATE_BREAK_MODAL]: 'createBreakModal',
    [ToggleActions.ADD_NEW_REGISTER]: 'addNewRegister',
    [ToggleActions.TUNNEL_SUBDIVISION]: 'tunnelSubdivisions',
    [ToggleActions.GANTT_CHART_DATES]: 'ganttChartDates',
}

const switchesReducer = (data = initialSwitches, action) => {
    let type = toggleActionsMap[action.type]
    let newData = {...data}
    if (type) {
        newData[type] = !newData[type]
        if (action.data !== null) {
            newData[type] = action.data
        }
    }
    return newData
}

export default switchesReducer;